/** 线性标注文字相对尺寸线中点沿垂直方向的偏移量，使文字浮在尺寸线外侧 */
export const LINEAR_DIMENSION_TEXT_OFFSET = 250;

/** 线性标注辅助线越过偏移端点后的延长长度 */
export const LINEAR_DIMENSION_ASSIST_LINE_OFFSET = 50;

/** 线性标注两端 45° 辅助斜线的半长 */
export const LINEAR_DIMENSION_ASSIST_SLASH_LINE_OFFSET = (LINEAR_DIMENSION_ASSIST_LINE_OFFSET * Math.SQRT2) / 2;
